import React from 'react'
import {Link} from 'react-router-dom'

import {NearestShowroomLocation} from '../../typedefs/showrooms'
import * as URLS from '../../urls'

import Button from '../Button'
import Svg from '../Svg'

import tapeMeasureIcon from '../../../../svg/tape-measure.svg'

interface Props {
  nearestShowroom: NearestShowroomLocation
}

const FitOptions: React.FC<Props> = ({nearestShowroom}) => (
  <div className="c-fit-options">
    <header className="c-fit-options__header">
      <Svg className="c-fit-options__icon" src={tapeMeasureIcon} />
      <h3 className="c-fit-options__heading">
        Get personal fit and style advice with a visit to our showroom.
      </h3>
    </header>
    <div className="c-fit-options__nearest-sr">
      <p className="c-fit-options__label">Nearest Showroom:</p>
      <p className="c-fit-options__location">
        {nearestShowroom.city}, {nearestShowroom.state}
      </p>
      <div className="c-fit-options__button">
        <Button
          fullWidth
          isLink
          to={`${URLS.SHOWROOMS}/${nearestShowroom.slug}/bookappointment-type`}
        >
          Book Appointment
        </Button>
      </div>
    </div>
    <Link className="c-fit-options__link" to={URLS.SHOWROOMS}>
      See All Locations
    </Link>
  </div>
)

export default FitOptions
